let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("owGso")).then(() => parcelRequire('hPioD'));